module.exports = __webpack_public_path__ + "static/logo_3x2-b31e7cb01b18267db06e880432d1d057.png";